<template>
  <span class="print-view">
    <div class="vx-row mb-16 ml-4">
      <div class="vx-col w-1/6 mt-3">
        <v-select :clearable="false" label="name" v-model="print_pack_size" :reduce="option => option.value"
          class="mt-6 w-full"
          :options="pack_size_options"
          :dir="$vs.rtl ? 'rtl' : 'ltr'" />
      </div>
      <div class="vx-col w-1/6 mr-4">
        <vs-button class="mt-8" type="border" @click="onClickPrint">Print & Download</vs-button>
      </div>
    </div>
    <page id="printDiv" size="A4">
      <div class="vx-row mb-0">
        <div class="vx-col w-full">
          <vx-card id="formulation-label-pop-up" no-shadow class="bg-white" style="color: #000000 !important;">
            <div class="vx-row mb-2 mt-0">
              <h3 class="ml-8 uppercase font-semibold" style="color: #000000; font-size: 25px !important;">
                {{ orderDetails.formulation_name }} {{ orderDetails.formulation_code }}
              </h3>
            </div>
            <div class="vx-row mt-0">
              <div class="vx-col w-2/5 md:mb-0">
                <div class="grid grid-cols-2">
                  <div v-for="(img, index)  in label_images" :key="'image' + index">
                    <img class="responsive"
                      :src="'https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/UL-Images/' + img" alt="">
                  </div>
                </div>
              </div>
              <div class="vx-col w-3/5 md:mb-0">
                <div class="table-container">
                  <table class="table-auto">
                    <tbody>
                      <tr>
                        <td class="px-0 py-0 font-medium">Product Code</td>
                        <td class="px-4 py-0">{{ customer_item_code }}</td>
                      </tr>
                      <tr>
                        <td class="px-0 py-0 font-medium">Legal Name</td>
                        <td class="px-4 py-0">
                          <!-- <span v-if="show_formulation_percentage">{{ percentage_label || orderDetails.formulation_legal_name }}</span> -->
                          <span>{{ orderDetails.formulation_legal_name || 'N/A' }}</span>
                        </td>
                      </tr>
                      <tr v-if="orderDetails.formulation_alternative_legal_name && orderDetails.formulation_alternative_legal_name !== ''" >
                        <td class="px-0 py-0 font-medium">Alternative Legal Name</td>
                        <td class="px-4 py-0">
                          {{ orderDetails.formulation_alternative_legal_name }}
                        </td>
                      </tr>
                      <tr>
                        <td class="px-0 py-0 font-medium">Batch</td>
                        <td class="px-4 py-0">{{ orderDetails.work_order_code }}/{{ orderDetails.formulation_code }}</td>
                      </tr>
                      <tr>
                        <td class="px-0 py-0 font-medium"> Weight (KG)</td>
                        <td class="px-4 py-0">{{ print_pack_size }}</td>
                      </tr>
                      <tr>
                        <td class="px-0 py-0 font-medium">Manufactured</td>
                        <td class="px-4 py-0">{{ manufacture_date }}</td>
                      </tr>
                      <tr>
                        <td class="px-0 py-0 font-medium">Best Before</td>
                        <td class="px-4 py-0">{{ expiration_date }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- <div class="vx-row">
                  <div class="vx-col 1/3">
                    Customer Product Code
                  </div>
                  <div class="vx-col 2/3">
                    {{ customer_item_code }}
                  </div>
                </div> -->
                <!-- <div class="vx-row">
                  <div class="vx-col 1/3">
                    Legal Name
                  </div>
                  <div class="vx-col 2/3">
                    {{ orderDetails.formulation_legal_name || 'N/A' }}
                  </div>
                </div> -->
                <!-- <div class="vx-row">
                  <div class="vx-col 1/3">
                    Batch
                  </div>
                  <div class="vx-col 2/3">
                    {{ orderDetails.work_order_code }}/{{ orderDetails.formulation_code }}
                  </div>
                </div> -->
                <!-- <div class="vx-row">
                  <div class="vx-col 1/3">
                    Weight (KG)
                  </div>
                  <div class="vx-col 2/3">
                    {{ print_pack_size }}
                  </div>
                </div> -->
                <!-- <div class="vx-row">
                  <div class="vx-col 1/3">
                    Manufactured
                  </div>
                  <div class="vx-col 2/3">
                    {{ orderDetails.actual_end_date || orderDetails.work_order_date }}
                  </div>
                </div> -->
                <!-- <div class="vx-row">
                  <div class="vx-col 1/3">
                    Best Before
                  </div>
                  <div class="vx-col 2/3">
                    {{ best_before }}
                  </div>
                </div> -->
                <div class="vx-row" v-if="orderDetails.storage_condition">
                  <div class="vx-col 1/3">

                  </div>
                  <div class="vx-col 2/3">
                    {{ orderDetails.storage_condition || '' }}
                  </div>
                </div>
                <h6 class="mb-0 mt-1 font-bold" style="color: #000000; font-size: 12px !important;">{{ EGHS }}</h6>
                <small class="" v-for="(label, index) in groupedLabelData.EHSHP" :key="'danger1' + index">
                  <!--            {{ label.data.split('-')[1] }} <br>-->
                  {{ label.data }} <br>
                </small>
                <small class="" v-for="(label, index) in groupedLabelData.EPHHH" :key="'danger5' + index">
                  {{ label.data }} <br>
                </small>
                <small class="" v-for="(label, index) in groupedLabelData.EHSPO" :key="'danger2' + index">
                  <!--            {{ label.data.split('-')[1] }} <br>-->
                  {{ label.data }} <br>
                </small>
                <small class="" v-for="(label, index) in groupedLabelData.EGOH" :key="'danger3' + index">
                  {{ label.data }} <br>
                </small>
                <small class="" v-for="(label, index) in groupedLabelData.RU" :key="'danger4' + index">
                  {{ label.data }} <br>
                </small>
                <!-- <span class="ml-2" v-for="(label, index) in groupedLabelData.FPC" :key="'danger6' + index">
                  {{ label.caption }} - {{ label.data }} <br>
                </span> -->
                <!--          <span class="ml-12" v-for="(label , index) in groupedLabelData.ESPI" :key="'other_info'+index">-->
                <!--            {{ label.data }} <br>-->
                <!--          </span>-->
                <span class="font-semibold">
                  <!-- {{ UNA }} {{ un_proper_shipping_name }} <span v-if="!un_proper_shipping_name">{{ PYST }}</span> {{ ODR }} {{ HCA }} {{ PGA }} {{ TRCA }} -->
                  {{ UNA }} {{ un_proper_shipping_name }} {{ ODR }} {{ HCA }} {{ PGA }} {{ TRCA }}
                </span> <br>
                <div v-if="UNA.includes('UN')" class="ml-8 mt-1" style="font-size: 50px; color: #000000 !important;"> {{ UNA }} </div>
                <!-- <div class="mt-4">
                  <img v-if="is_halal" id="logo" class="ml-2" style="display: inline-block;"
                  src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/UL-Images/halal.jpg" alt="Halal Logo"
                  width="50" height="" />
                  <img v-if="is_kosher" id="logo" class="ml-2" style="display: inline-block;"
                    src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/UL-Images/kosher.jpg" alt="Halal Logo"
                    width="50" height="" />
                </div> -->
              </div>
            </div>
            <div class="vx-row mb-0 mt-0">
              <div class="vx-col w-2/5 md:mb-0">

              </div>
              <div class="vx-col w-3/5 md:mb-0">
                <img v-if="is_halal" id="logo" class="ml-2" style="display: inline-block;"
                  src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/UL-Images/halal.jpg" alt="Halal Logo"
                  width="60" height="" />
                <img v-if="is_kosher" id="logo" class="ml-2" style="display: inline-block;"
                  src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/UL-Images/kosher.jpg" alt="Kosher Logo"
                  width="60" height="" />
                <img v-if="is_organic" id="logo" class="ml-2" style="display: inline-block;"
                  src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/UL-Images/organic_2.png" alt="Organic Logo"
                  width="60" height="" />
              </div>
            </div>
            <div class="vx-row mb-0 mt-0">
              <img id="logo" class="ml-2" src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/images/ITS-Logo.png"
                alt="Logo" width="40" height="" />
              <h6 class="ml-2 mt-1" style="color: #000000; font-size: 10px !important;">
                Innovation House, Abex Road, Newbury, Berkshire, RG14 5EY
              </h6>
            </div>
          </vx-card>
        </div>
      </div>
    </page>
  </span>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const UlRepository = RepositoryFactory.get('ul');

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import { Printd } from "printd";
import vSelect from 'vue-select'

const ManufacturingRepository = RepositoryFactory.get('manufacturing')
const InventoryRepository = RepositoryFactory.get('inventory')
const FormulationsRepository = RepositoryFactory.get('formulations')

function initialState() {
  return {
    open: false,
    orderDetails: {},
    labelData: [],
    quantity: '',
    best_before: '',
    customer_item_code: '',
    groupedLabelData: {
      UNA: []
    },
    label_images: [],
    print_pack_size: 5,
    WOId: '',
    pack_size_options: [{ name: 'Print 5Kg version', value: 5 }, { name: 'Print 10Kg version', value: 10 }],
    show_formulation_percentage: false,
    percentage_label: '',
    manufacture_date: '',
    expiration_date: '',
  }
}

export default {
  name: "WoLabelPrintView",
  data() {
    return initialState()
  },
  async mounted() {
    this.WOId = this.$route.params.id
    await this.getWorkOrderDetails()
    if(this.show_formulation_percentage) {
      await this.getFormulationData()
    }
    await this.getLabelData()
    await this.generateDate()
  },
  methods: {
    async getWorkOrderDetails() {
      const { data } = (await ManufacturingRepository.getWorkOrder(this.WOId)).data;
      this.orderDetails = data;
      this.show_formulation_percentage = data.show_formulation_percentage
      if(this.orderDetails.pack_size) {
        this.print_pack_size = Number(this.orderDetails.pack_size).toFixed(4)
        this.pack_size_options.push({name: `Print ${this.print_pack_size}Kg version (from wo)`, value: this.print_pack_size})
      }
    },
    async getFormulationData(){
      const { data } = (await FormulationsRepository.details(this.orderDetails.formulation_id)).data
      let formulation = data
      let rm_items = []
      
      if (formulation.formulation_items.length > 0) {
        rm_items = formulation.raw_material_items.concat(formulation.formulation_items)
      } else {
        rm_items = formulation.raw_material_items
      }
      if(formulation.formulation_type === 'spray dry powder' && formulation.spray_dry_carriers.length > 0) {
        rm_items = rm_items.concat(formulation.spray_dry_carriers)
      }

      let total = 0;
      rm_items.forEach((m) => {
        total = total + Number(m.quantity)
      })
      total = total.toFixed(2)

      rm_items = rm_items.map((n) => {
        n.percentage = ((n.quantity / total) * 100).toFixed(2)
        return n
      })

      this.percentage_label = rm_items
        .map(item => {
          const label = item.company_product_name || item.name;
          return `${label} (${item.percentage}%)`;
        })
        .join(", ");

    },
    async getLabelData() {
      const vue = this;
      await this.$vs.loading()
      try {
        const { data } = await UlRepository.getFormulationLabel(this.orderDetails.formulation_code.replace('-', ''));
        this.labelData = data.data
        this.labelData = this.labelData.filter((x) => {
          return !(x.data.match(/^&+$/) || x.data === "")
        })
        this.groupedLabelData = _.groupBy(this.labelData, label => label.data_code);
        this.label_images = this.labelData.filter((x) => x.data.includes('.png')).map((y) => y.data)
        for (let i of Array(4 - this.label_images.length).keys()) {
          this.label_images.push('no-symbol.png')
        }
      } catch (e) {
        this.$vs.loading.close()
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async generateDate() {
      if (this.orderDetails.order_items.length > 0 && this.$route.query.so_id) {
        const find = this.orderDetails.order_items.find((x) => x.order_id == this.$route.query.so_id)
        this.customer_item_code = find && find.customer_item_code ? find.customer_item_code : this.orderDetails.formulation_code
      } else if(this.$route.query.so_id) {
        const find = this.orderDetails.formulation_stock.find((x) => x.product_order.id == this.$route.query.so_id)
        this.customer_item_code = find && find.customer_product_code && find.customer_product_code !== '-' ? find.customer_product_code : this.orderDetails.formulation_code
      } else {
        this.customer_item_code = this.orderDetails.formulation_code
      }
      if(this.$route.query.stock_id){
        const find = this.orderDetails.formulation_stock.find((x) => x.id == this.$route.query.stock_id)
        this.manufacture_date = find ? find.manufacture_date : ''
        this.expiration_date = find ? find.expiration_date : ''
      } else {
        this.manufacture_date = this.orderDetails.actual_start_date || this.orderDetails.work_order_date
      }
    },
    onClickPrint() {
      window.print()
    },
  },
  computed: {
    UNA: function () {
      const find = this.labelData.find((x) => x.data_code === 'UNA')
      if (find) { return find.data } else { return '' }
    },
    PYST: function () {
      const find = this.labelData.find((x) => x.data_code === 'PYST')
      if (find) { return find.data }
    },
    ODR: function () {
      const find = this.labelData.find((x) => x.data_code === 'ODR')
      if (find) { return `${find.data},` }
    },
    PGA: function () {
      const find = this.labelData.find((x) => x.data_code === 'PGA')
      if (find) { return `${find.data},` }
    },
    FPC: function () {
      const find = this.labelData.find((x) => x.data_code === 'FPC')
      if (find) { return find.data }
    },
    HCA: function () {
      const find = this.labelData.find((x) => x.data_code === 'HCA')
      if (find) { return `${find.data},` }
    },
    EGHS: function () {
      const find = this.labelData.find((x) => x.data_code === 'EGHS')
      if (find) { return find.data }
    },
    TRCA: function () {
      const find = this.labelData.find((x) => x.data_code === 'TRCA')
      if (find) { return `(${find.data})` }
    },
    un_proper_shipping_name: function () {
      const objects = this.labelData.filter((x) => x.caption === 'UN proper shipping name' && x.data_code === "EPNA")
      
      if (objects.length === 0) {
        return ''
      }
      
      // Find prod_text and prod_data objects
      const prodTextObj = objects.find(obj => obj.data_type === 'prod_text')
      const prodDataObj = objects.find(obj => obj.data_type === 'prod_data')
      
      // If we only have one object or no prod_text, return the first object's data
      if (!prodTextObj) {
        return objects[0].data
      }
      
      let result = prodTextObj.data
      
      // If we have prod_data, process replacements
      if (prodDataObj && prodDataObj.data) {
        // Remove && identifier from prod_data
        const replacementText = prodDataObj.data.replace(/^&&/, '')
        
        // Replace placeholders .?, .?1, .?2, etc.
        result = result.replace(/\.(\?\d*)/g, replacementText)
      }
      
      return result + ','
    },
    is_halal: function () {
      return ['certified'].includes(this.orderDetails.formulation_halal)
    },
    is_kosher: function () {
      return ['certified'].includes(this.orderDetails.formulation_kosher)
    },
    is_organic: function () {
      return ['certified'].includes(this.orderDetails.formulation_organic)
    },
  },
  mixins: [SuccessMessage, ErrorMessages],
  components: {
    'v-select': vSelect,
  },
}
</script>

<style lang="scss">
page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.1cm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

page[size="A4"] {
  width: 21cm;
  //height: 15cm;
  height: fit-content;
}

@media print {
  @page {
    size: A5 landscape;
    width: 21cm;
    height: fit-content !important;
  }

  .print-view {
    * {
      visibility: hidden;
    }

    #content-area {
      margin: 0 !important;
    }

    #printDiv,
    #printDiv * {
      visibility: visible;
    }

    #printDiv {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}


html,
body {
  -webkit-print-color-adjust: exact !important;
}

.clearfix:after {
  content: "";
  display: table;
  clear: both;
}

a {
  color: #0087C3;
  text-decoration: none;
}

body {
  position: relative;
  margin: 0 auto;
  color: #000000 !important;
  background: #FFFFFF;
  font-family: Arial, sans-serif;
  font-size: 10px;
  line-height: 1.1;
}

div#full-wrap {
  width: 40cm;
  max-width: 100%;
  margin: 0 auto;
}

h4 {
  font-size: 24px;
}

p {
  font-size: 16px;
  margin: 0;
  color: #000000 !important;
}

.sml {
  font-size: 14px;
}

main {
  padding: 0px 10px 20px 10px;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 0;
  font-size: 10px;

}

table th,
table td {
  padding: 20px;
  text-align: center;
  vertical-align: top;
}

table th {
  white-space: nowrap;
  font-weight: normal;
  color: #000;
}

table td {
  text-align: left;
}

table.txt-center td {
  text-align: center;
}

table.txt-left td {
  text-align: left;
}

table.txt-right td {
  text-align: right;
}


div#user-top {
  width: 100%;
  margin: 5em auto 2em auto;
}

div#user-top table {
  margin: 0 auto .8em auto;
  text-align: center;
  width: 100%;
}

div#user-top table td {
  padding: 5px 8px;
  font-size: 18px;
}

div#user-top .head {
  vertical-align: middle;
  text-align: center;

}

table#in-tbl {
  width: 100%;

}

table#in-tbl td {
  border: 2px solid #000;

}

td.no-bd {
  border-left: 0px !important;
  border-bottom: 0px !important;
}

table.no-bd-tbl td {
  border: 0px !important;
  padding: 0 !important;
}

table.no-bd-tbl {
  margin-bottom: 0 !important;
}

.align-left {
  text-align: left !important;
}

.align-right {
  text-align: right !important;
}

footer {
  padding: 0 30px;
}
</style>
